import React from 'react';

function PartnerIntro() {
  return (
    <section className="partnerIntro">
      <h1>Partner With Us</h1>
      <p>
        Our team is dedicated to delivering exceptional results through collaboration,
        innovation, and expertise. With years of experience in the real estate industry,
        we are committed to helping our partners achieve their goals.
      </p>
    </section>
  );
}

export default PartnerIntro;
